import React from "react"
import styled from "styled-components"
import colors from "../../styles/colors";
import breakpoints from "../../styles/breakpoints";

const Container = styled.div`
  width: 100%;
  background: ${colors.white};
  border: 1px solid ${colors.greyDark};
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Content = styled.div`
  width: 100%;
  box-sizing: content-box;
  max-width: 480px;
  padding: 80px 32px;
  
  @media(min-width: ${breakpoints.md}) {
    padding: 160px 64px;
  }
`;

const BorderedBlock = ({onClick, children}) => {
  return (
    <Container>
      <Content>
        {children}
      </Content>
    </Container>
  );
};

export default BorderedBlock